import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHTituloIns = async (credentials, data) => {
    const body = {
        service: "RNHTituloIns",
        params: {
            rnhTituloCod: data?.cod || null,
            rnhTituloNombre: data?.name || null,
            rnhTituloRequiereMatricula: data?.matricula || null
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
